export default __webpack_public_path__ + "static/media/goalPage.5665f7b0.png";